import React from "react";

interface BadgeProps {
  text: string;
  icon?: React.ReactNode;
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({ text, icon, className }) => {
  return (
    <div
      className={`inline-flex items-center px-3 py-1 rounded-full text-sm bg-gray-100 dark:bg-gray-700 text-text-primary dark:text-text-primary-dark ${className}`}
    >
      {icon && <span className="mr-1">{icon}</span>}
      <span>{text}</span>
    </div>
  );
};

export default Badge;
